module.exports = __webpack_public_path__ + "img/cons_4.952f25d2.jpg";